import { render } from "./ClassRoomList.vue?vue&type=template&id=87599962&scoped=true"
import script from "./ClassRoomList.vue?vue&type=script&lang=js"
export * from "./ClassRoomList.vue?vue&type=script&lang=js"

import "./ClassRoomList.vue?vue&type=style&index=0&id=87599962&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Management_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87599962"]])

export default __exports__